import { closeLegend as closeLegendAction } from '@/redux/legend/legend.slice';
import { store } from '@/redux/store';

export const closeLegend = (): void => {
  const { dispatch } = store;

  dispatch(closeLegendAction());
};
